import { cx } from '@linaria/core'
import type React from 'react'
import { checkboxClass } from './style'

export const VariantCheckbox = ({ className, ...props }: React.ComponentProps<'input'> & { className?: string }) => {
  const classNames = cx(checkboxClass, className)
  return <input className={classNames} {...props} type="checkbox" />
}
